export default __webpack_public_path__ + "static/step-one-8a18bb9734a4b7b23f2e5b0dc89b6740.png";